module.exports = __webpack_public_path__ + "static/img/h5-hero-bg-6d0c75.45f624d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/h5-hero-bg-6d0c75.png
// module id = eHEk
// module chunks = 1